// Utilities
import * as React from "react";
import { DndProvider } from "react-dnd";
import { isRefable } from "react-dnd/dist/esm/decorators/utils";
import { MultiBackend, createTransition } from "react-dnd-multi-backend/dist/esm";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
let customBackends;
/**
 * Returns custom dnd backend that updates backend type.
 */ function getCustomBackendOptions(setDndBackend) {
    if (!customBackends) {
        customBackends = HTML5toTouch;
        // Replace the transitions with ones that will add/remove the touch preview element
        // Transitions are used in react-dnd-multi-backend to determine whether the dnd backend
        // should be switched to another backend based on the event.
        // We add logic to the transition callback to update the AppContext to the current dnd backend.
        customBackends.backends[0].transition = createTransition("mousedown", (event)=>{
            if (!!event.type && -1 === event.type.indexOf("touch") && -1 !== event.type.indexOf("mouse")) {
                setDndBackend("Html5");
                return true;
            }
            return false;
        });
        customBackends.backends[1].transition = createTransition("touchstart", (event)=>{
            if (event.touches != null) {
                setDndBackend("Touch");
                return true;
            }
            return false;
        });
    }
    return customBackends;
}
/**
 * Wraps a component with Drag and Drop context provider. Returns class component.
 * @param Component to be wrapped with DnD context
 * @param setDndBackend Callback to be called when the dnd backend changes
 */ export function withDndContext(Component, setDndBackend) {
    return class extends React.Component {
        render() {
            return /*#__PURE__*/ React.createElement(DndProvider, {
                backend: MultiBackend,
                options: getCustomBackendOptions(setDndBackend)
            }, /*#__PURE__*/ React.createElement(Component, {
                ...this.props,
                ref: isRefable(Component) ? this.ref : null
            }));
        }
        constructor(props){
            super(props), this.ref = /*#__PURE__*/ React.createRef();
        }
    };
}
